import React, { useEffect } from "react";
import { loadGallery, addGallery, selectGallery } from "./gallerySlice";
import { useDispatch, useSelector } from "react-redux";

const Gallery = () => {
  const galleryState = useSelector(selectGallery);
  const galleryData = galleryState.gallery;
  const dispatch = useDispatch();

  //load and render gallery data upon first time page load
  useEffect(() => {
    dispatch(loadGallery());
  }, []);

  return (
    <>
      {/* Page-Banner section starts...*/}
      <section>
        <div className="pageBanner">
          <div className="bannerContent">
            <h1 className="page-banner-title">Gallery</h1>
          </div>
        </div>
      </section>
      {/* Page-Banner section ends...*/}

      <div className="container d-flex flex-column justify-content-center align-items-center " style={{padding:"50px 15px"}}>
        {/* <h1 className="text-center">Gallery</h1> */}
        {galleryData.map((galleryItem, index) => {
          return (
            <>
              <h4 style={{textAlign:"justify",color:"darkblue",fontWeight:"bold"}}>{galleryItem.description}</h4>
              <br/>
              <br/>
              {galleryItem.imgDetail.map((picItem, index) => {
                return (
                  <div className="m-3">
                    <figure className="figure">
                      <img
                        key={`gallery_img_${index}`}
                        src={picItem.img}
                        className="figure-img img-fluid rounded img-thumbnail"
                        style={{ border: "1px solid #e6c200" }}
                        alt={`pic-${index}`}
                      />
                      <figcaption
                        key={`gallery_caption_${index}`}
                        className="figure-caption text-center fs-6 fw-semibold"
                      >
                        {picItem.caption || ""}
                      </figcaption>
                    </figure>
                  </div>
                );
              })}
            </>
          );
        })}
      </div>
    </>
  );
};

export default Gallery;
